'use es6';

export var PENDING = 'PENDING';
export var SUBMITTED = 'SUBMITTED';
export var SUCCEEDED = 'SUCCEEDED';
export var FAILED = 'FAILED';
export var CANCELED = 'CANCELED';